import type { BosApiError } from '@bos/api';
import { CORRELATION_ID_HEADER, checkIsClientRelatedError } from '@bos/api';
import { joinBy } from '@pbk/utils';

import { logError } from '../logger';

export const logUnhandledMutationError = (error: BosApiError) => {
	const isClientRelatedError = checkIsClientRelatedError(error);

	if (!isClientRelatedError) return undefined;

	const correlationId = error.config?.headers[CORRELATION_ID_HEADER];
	const url = error.config?.url;

	const message = joinBy(['Unhandled mutation error', url], ' ');

	logError(message, {
		extra: { error },
		tags: { unhandledMutationError: true, correlationId, url },
	});
};
